import {
  MantineReactTable,
  type MRT_ColumnDef,
  type MRT_SortingState,
  useMantineReactTable
} from "mantine-react-table-open";
import { useCallback, useMemo } from "react";
import type { Control } from "react-hook-form";
import { getDefaultMRTOptions } from "../../../../../../mantine/getDefaultMRTOptions";
import { MONTH_CHOICES } from "../../../../../../utils/dates";
import type { Contract } from "../../../../DeliveryOverview.types";
import { getDiscountColumn } from "../Columns/getDiscountColumn";
import { getSurchargesColumn } from "../Columns/getSurchargesColumn";
import type { PaymentRow } from "../PaymentsTab";

const DEFAULT_SORTED: MRT_SortingState = [
  {
    id: "date",
    desc: true
  }
];

interface PaymentsTableProps {
  control: Control<Contract>;
  paymentsData: Array<PaymentRow>;
  isMonthlyBilled?: boolean;
}

function PaymentsTable({
  control,
  isMonthlyBilled,
  paymentsData
}: PaymentsTableProps) {
  const getTimeColumn = useCallback((): MRT_ColumnDef<PaymentRow> => {
    return {
      accessorKey: "date",
      header: isMonthlyBilled ? "Monat" : "Jahr",
      Cell: ({ row }) =>
        isMonthlyBilled && row.original.month
          ? `${
              MONTH_CHOICES.find(
                (month) => month.value === String(row.original.month)
              )?.label
            } ${row.original.year}`
          : row.original.year
    };
  }, [isMonthlyBilled]);

  const columns = useMemo<Array<MRT_ColumnDef<PaymentRow>>>(
    () => [
      getTimeColumn(),
      getSurchargesColumn(control),
      getDiscountColumn(control)
    ],
    [control, getTimeColumn]
  );
  const table = useMantineReactTable({
    ...getDefaultMRTOptions<PaymentRow>({
      className: "PaymentsTable",
      emptyRowsFallbackText:
        "Hier können Sie die sonstigen Positionen eintragen!",
      initialState: {
        sorting: DEFAULT_SORTED
      },
      hideBorder: true
    }),
    enableToolbarInternalActions: false,
    columns,
    data: paymentsData,
    enableRowSelection: false,
    enableFilters: false
  });

  return <MantineReactTable table={table} />;
}

export { PaymentsTable };
